var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineProfileTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.43 21.1-1.52-1.52a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.99.99L18.47 17c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.04 3.04c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.08 11.62a.543.543 0 0 0-.18 0C9 11.53 6.81 9.25 6.81 6.44c-.01-1.38.53-2.68 1.51-3.66a5.16 5.16 0 0 1 3.67-1.53c2.86 0 5.19 2.33 5.19 5.19 0 2.81-2.19 5.08-4.99 5.18h-.11zm-2.7-7.79c-.69.7-1.07 1.62-1.07 2.6 0 2 1.56 3.62 3.55 3.68.06-.01.19-.01.32 0 1.97-.09 3.5-1.7 3.5-3.68 0-2.02-1.66-3.68-3.69-3.68-.99 0-1.91.39-2.61 1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56 21.05c-1.39-.93-2.15-2.2-2.15-3.57 0-1.37.77-2.63 2.15-3.55 2.99-2 7.85-2 10.84 0 .34.23.44.7.21 1.04-.23.35-.7.44-1.04.21-2.49-1.66-6.69-1.66-9.18 0-.96.64-1.48 1.45-1.48 2.3 0 .85.52 1.68 1.48 2.32 1.21.81 2.84 1.25 4.59 1.25a.755.755 0 0 1 .01 1.51c-2.04 0-3.97-.53-5.43-1.51z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineProfileTick);
export default __webpack_public_path__ + "static/media/vuesax-outline-profile-tick.e7417f0f8f393946d0520f6d16269476.svg";
export { ForwardRef as ReactComponent };